import React, { useEffect, useState } from "react";
import './AccountView.css'
import TauriImage from "../../TauriImage/TauriImage";
import appURL from '../../../appURL.json';
import { transformPlanningAccount } from "../PlanningFactoryData/PlanningFactoryData";
import TauriLoader2 from "../../TauriLoader2/TauriLoader2";
import { getAll, syncDataToLocal } from "../../../localDB";
import AccountDetailsModal from "../../OpalCoverageLayout/AccountDetailsModal/AccountDetailsModal";
import TauriCustomPaganation from "../../TauriCustomPaganation/TauriCustomPaganation";

const statusAccount = {
    0: "#C2C0C0",
    1: "#FD9B09",
    2: "#079D33"
}

const AccountsView = ({ id }) => {
    const [search, setSearch] = useState('');
    const [itemList, setItemList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedAccID, setSelectedAccID] = useState(null);
    const [showAccountDetails, setShowAccountDetails] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [displayPerPage, setDisplayPerPage] = useState(20);

    const fetchData = async (cycleID) => {
        setLoading(true);
        try {
            const isOnline = JSON.parse(localStorage.getItem("isOnline"));
            const hasInternet = navigator.onLine;

            let data = [];

            if (isOnline && hasInternet) {
                const token = localStorage.getItem("token");
                const devId = localStorage.getItem("devId");

                const storedPermission = localStorage.getItem("permission");
                const permission = JSON.parse(atob(storedPermission));

                const response = await fetch(
                    `${appURL.API_Worksheet}/accounts/${Number(permission?.coverage?.employee_id)}/${Number(cycleID)}`,
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`,
                            'X-ETR-Device-ID': devId
                        }
                    }
                );

                if (!response.ok) return;

                const res = await response.json();
                data = await transformPlanningAccount(res.accounts);

                await syncDataToLocal("PlanningAccounts", data);

                window.dispatchEvent(new Event("RefreshPlanningAccounts"));
            } else {
                data = await getAll("PlanningAccounts");
            }

            setItemList(data);

        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (id) {
            fetchData(id);
        }
    }, [id]);

    const filteredItems = itemList.filter((item) => {
        if (!search) return true;

        const lower = search.toLowerCase();
        return (
            item.Name?.toLowerCase().includes(lower) ||
            item.Code?.toLowerCase().includes(lower)
        );
    });

    const sortedItems = [...filteredItems].sort((a, b) =>
        (a.Name || "").localeCompare(b.Name || "")
    );

    const totalItems = sortedItems.length;
    const totalPages = Math.ceil(totalItems / displayPerPage);

    const startIndex = (currentPage - 1) * displayPerPage;
    const paginatedItems = sortedItems.slice(
        startIndex,
        startIndex + displayPerPage
    );

    useEffect(() => {
        setCurrentPage(1);
    }, [search]);

    useEffect(() => {
        if (currentPage > totalPages) {
            setCurrentPage(totalPages || 1);
        }
    }, [totalPages]);


    const handleRowClick = (accID) => {
        setSelectedAccID(accID);
        setShowAccountDetails(true);
    }

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleDisplayPerPage = (count) => {
        setDisplayPerPage(count);
        setCurrentPage(1);
    };

    return (
        <div className="opal-account-view w-100">
            <div className="filter-section d-flex align-items-center justify-content-end mb-4">
                <div className="search-section d-flex align-items-center p-2">
                    <TauriImage
                        localImage={"/Images/symbols--search.svg"}
                        alt="icon"
                        color={"#7FA6D3"}
                    />
                    <div className="input-group">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Type to Search"
                            autoComplete="new-password"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </div>
                </div>
            </div>
            <div className="account-list-table">
                {loading ? (
                    <TauriLoader2 width="2.5rem" height="2.5rem" borderwidth="0.35rem" color="#1D5D9B" />
                ) : (
                    <table className="table w-100 border-collapse">
                        <thead className="account-list-table-header">
                            <tr>
                                <th style={{ width: "2rem" }} className="text-center col-check">
                                    <TauriImage
                                        localImage={"/Images/carbon--settings.svg"}
                                        alt="icon"
                                        color={"#000"}
                                    />
                                </th>
                                <th style={{ width: "10rem" }}>REFERENCE CODE</th>
                                <th>ACCOUNT NAME</th>
                                <th style={{ width: "12rem" }}>LAST VISITED CYCLE</th>
                                <th style={{ width: "16rem" }}>SYSTEM NOTES</th>
                            </tr>
                        </thead>
                        <tbody className="account-list-table-body">
                            {paginatedItems.map((row, idx) => (
                                <tr
                                    key={row.ID}
                                    className={idx % 2 === 0 ? "" : "even"}
                                    onClick={() => handleRowClick(row.ID)}
                                    style={{ cursor: "pointer" }}
                                >
                                    <td>
                                        <TauriImage
                                            localImage={"/Images/circle-check.svg"}
                                            alt="icon"
                                            color={statusAccount[row.Status]}
                                        />
                                    </td>
                                    <td>{row.Code}</td>
                                    <td>{row.Name}</td>
                                    <td>{row.LastVisited}</td>
                                    <td>{row.ReasonID}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
            {(!loading && itemList.length > 0) &&
                <TauriCustomPaganation
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                    displayPerPage={displayPerPage}
                    onDisplayPerPage={handleDisplayPerPage}
                    totalItems={totalItems}
                />
            }

            <AccountDetailsModal show={showAccountDetails} onHide={() => setShowAccountDetails(false)} accID={selectedAccID} />
        </div>
    );
};

export default AccountsView;
